import type { IntlShape } from 'react-intl';

const getDefaultWaypointName = (displayIndex: number, intl: IntlShape): string =>
  intl.formatMessage({ defaultMessage: 'Waypoint {name}' }, { name: displayIndex + 1 });

export default getDefaultWaypointName;
